export const REVIEW_POLICY_OPEN_MODAL_EVENT = "REVIEW_POLICY_OPEN_MODAL_EVENT";
